import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { EducationalPopover } from '@liveauctioneers/hammer-ui-core/educationalPopover';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import ms from 'ms';
import { useCallback, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getCookie, setCookie } from '@/redux/modules/cookies';

type EducationalTipExcludeHousesProps = {
    anchorSelect: string;
};

const COOKIE_MAX_AGE = ms('360d');
const COOKIE_NAME = 'excludeAuctionHousesEducationalPopoverDismissed';
const COOKIE_BODY = 'true';

export const EducationalTipExcludeHouses = ({ anchorSelect }: EducationalTipExcludeHousesProps) => {
    const dispatch = useAppDispatch();
    const dismissed = useAppSelector((state) => getCookie(state, COOKIE_NAME)) === COOKIE_BODY;
    const [showEducationalPopover, setShowEducationalPopover] = useState(!dismissed);
    const { formatMessage } = useIntl();
    const eduTipTitle = formatMessage({ id: 'excludeAuctionHousesFilter.educationalTip.title' });

    const handleEducationalTipAction = useCallback(() => {
        dispatch(
            setCookie({
                maxAge: COOKIE_MAX_AGE,
                name: COOKIE_NAME,
                value: COOKIE_BODY,
            })
        );
        setShowEducationalPopover(false);
    }, [dispatch]);

    return showEducationalPopover ? (
        <EducationalPopover
            anchorSelect={`#${anchorSelect}`}
            isInverse
            isOpen
            pages={[
                <>
                    <BodyPrimary className="text-primary">
                        <FormattedMessage id="excludeAuctionHousesFilter.educationalTip.description" />
                    </BodyPrimary>
                    <div className="flex justify-end">
                        <Button
                            onClick={handleEducationalTipAction}
                            size="sm"
                            variant="outlined"
                        >
                            <FormattedMessage id="excludeAuctionHousesFilter.educationalTip.action" />
                        </Button>
                    </div>
                </>,
            ]}
            style={{
                maxWidth: '373px',
            }}
            title={eduTipTitle}
        />
    ) : null;
};
